import React from "react";
import { Navigate } from "react-router-dom";
import { authStorageService } from "@/modules/auth/services/authStorageService";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const isAuthenticated = authStorageService.isAuthenticated();

  return isAuthenticated ? <>{children}</> : <Navigate to="/auth" replace />;
};

export default ProtectedRoute;
